import { EntityActionNames, IEntityAction } from '~src/spacesPlatform/components/ActionsMenu/EntityActions/IEntityAction';

import { getAppStore } from '../../app/AppStore';
import { AppState } from '../../app/state/AppState';
import { Messages } from '../../codegen/Localize';
import { IContentInfo } from '../../spacesPlatform/models/IContentInfo';
import { IWebEditFlowAction } from '../../ts/ServerApi/types/actionNames';
import { editFlow } from '../actions/EditFlowReduxAction';
import { selectEditingFlowsEnabled } from '../selectors/FlowSelectors';

export const EditFlowEntityAction: IEntityAction<IContentInfo<'flow'>, IWebEditFlowAction> = {
  name: EntityActionNames.EditFlow,
  translateName: Messages.editFlow,
  isVisible: (_, state: AppState) => state ? selectEditingFlowsEnabled(state) : selectEditingFlowsEnabled(getAppStore().getState()),
  isClickable: (availableActions: IWebEditFlowAction) => !!availableActions && availableActions.webEditFlow,
  createReduxAction: (targetItems: IContentInfo[]) => editFlow(targetItems[0])
};
